module.exports = __webpack_public_path__ + "static/remote-2020-bde89f9089f5fa7762331e4b4a924f5d.jpg";